import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  clearItemConditions,
  getItemConditions,
} from '../../../../actions/baggage/ItemCondition';
import Select from './Select';
import { optionsPropTypes } from './SelectPropTypes';
import {
  inputDefaultProps,
  inputPropTypes,
  metaDefaultProps,
  metaPropTypes,
} from '../input/InputPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';

const ItemConditionSelect = ({
  dispatchGetItemConditions,
  dispatchClearItemConditions,
  options,
  isLoading,
  onValueChange,
  input,
  meta,
  cleanWhenUnmount,
  isSpecial,
  isRegular,
  ...args
}) => {
  const storeKey = isSpecial ? 'special' : 'regular';

  useLayoutEffect(() => {
    const query = {
      ...DEFAULT_QUERY_GET_ALL,
      query: ['active:true'],
    };

    if (isSpecial !== undefined) {
      query.query.push(`isSpecial:${isSpecial}`);
    }

    if (isRegular !== undefined) {
      query.query.push(`isRegular:${isRegular}`);
    }

    dispatchGetItemConditions(query, storeKey);
    return () => {
      if (cleanWhenUnmount) {
        dispatchClearItemConditions(storeKey);
      }
    };
  }, []);

  return (
    <Select
      options={options}
      isLoading={isLoading}
      onValueChange={onValueChange}
      input={input}
      meta={meta}
      {...args}
    />
  );
};

ItemConditionSelect.propTypes = {
  dispatchGetItemConditions: PropTypes.func.isRequired,
  dispatchClearItemConditions: PropTypes.func.isRequired,
  options: optionsPropTypes.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onValueChange: PropTypes.func,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  meta: metaPropTypes,
  cleanWhenUnmount: PropTypes.bool,
  isSpecial: PropTypes.bool,
  isRegular: PropTypes.bool,
};

ItemConditionSelect.defaultProps = {
  onValueChange: undefined,
  isMulti: false,
  input: inputDefaultProps,
  meta: metaDefaultProps,
  cleanWhenUnmount: true,
  isSpecial: undefined,
  isRegular: undefined,
};

const mapStateToProps = ({ BaggageUnit }, { isSpecial }) => {
  const storeKey = isSpecial ? 'special' : 'regular';

  const itemConditionOptions = BaggageUnit.ItemCondition.getIn([
    storeKey,
    'content',
    'content',
  ]);

  const options = [];

  itemConditionOptions.forEach((itemCondition) => {
    options.push({
      value: itemCondition.id,
      label: itemCondition.name,
      requiredNote: itemCondition.requiredNote,
      isDefault: itemCondition.isDefault || false,
    });
  });

  return {
    options,
    isLoading: BaggageUnit.ItemCondition.getIn([storeKey, 'loading']),
  };
};

const mapDispatchToProps = {
  dispatchGetItemConditions: getItemConditions,
  dispatchClearItemConditions: clearItemConditions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemConditionSelect);
